// This file is responsible for managing the theme color toggle functionality. It reads the user's preferred color
// scheme from local storage or system preferences, applies the theme to the document, and binds event listeners
// to the toggle input and system preference changes.

const STORAGE_KEY = "ColorScheme";
const COOKIE_KEY = "color_scheme";

function setCookie(name, value, days = 365) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
}

function applyTheme(pref) {
  const html = document.documentElement;
  html.setAttribute("data-bs-theme", pref);
  setCookie(COOKIE_KEY, pref); // save it so we can access it on the server side
}

function readInitialPref() {
  // check local storage for a saved preference, otherwise use system preference, default to light.
  const saved = window.localStorage.getItem(STORAGE_KEY);
  const preferred =
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";

  return saved || preferred || "light";
}

function setToggleFromPref(pref) {
  // checked=false => light, checked=true => dark.
  const input = document.getElementById("colorSchemeToggle");
  if (!input) return;

  // Temporarily disable the toggle animation while syncing its state during initialization
  input.classList.add("no-transition");

  input.checked = pref === "dark";

  // Force the browser to apply the checked state immediately
  input.offsetHeight;

  input.classList.remove("no-transition");
}

function bindToggle() {
  const input = document.getElementById("colorSchemeToggle");
  if (!input) return;

  // Avoid double-binding on Turbo navigations
  if (input.__themeToggleBound) return;
  input.__themeToggleBound = true;

  input.addEventListener("change", (event) => {
    if (!event.isTrusted) return;

    const pref = input.checked ? "dark" : "light";
    window.localStorage.setItem(STORAGE_KEY, pref);
    applyTheme(pref);
  });
}

function initOrSyncTheme() {
  const initialPref = readInitialPref();
  applyTheme(initialPref);
  setToggleFromPref(initialPref);
  bindToggle();
}

// Run on first load
initOrSyncTheme();

// Run on every Turbo visit
document.addEventListener("turbo:load", () => {
  // Re-sync state and ensure toggle is bound for the newly rendered DOM
  initOrSyncTheme();
});
